module.exports={render:function (){with(this) {
  return _m(0)
}},staticRenderFns: [function (){with(this) {
  return _h('footer', ["\n  By ", _h('a', {
    attrs: {
      "href": "http://scriptist.io",
      "target": "_blank"
    }
  }, ["Scriptist"])])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-434a3bc6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
 ** module id = 167
 ** module chunks = 2
 **/